import { useRef } from "react";

import { Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";

import { useAuth } from "@/features/authentication";
import { OutletChartOfAccountSelect } from "@/features/outlet-chart-of-accounts";
import { CustomDatePicker, CustomInputField } from "@/features/ui";

import { PAYABLE_ACCOUNT_TYPES } from "../expense-accrual-form-constants";

export const GeneralInformationSection = ({ editMode = false }) => {
  const {
    control,
    register,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { outlet } = useAuth();

  // Jatuh Tempo trails Tanggal until the user sets it themselves. On edit the
  // stored value is already the user's answer, so it never trails.
  const dueDateTouched = useRef(editMode);

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        Informasi Umum
      </Typography>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            name="transactionDate"
            control={control}
            render={({ field, fieldState }) => (
              <CustomDatePicker
                value={field.value}
                onChange={(value) => {
                  field.onChange(value);
                  if (!dueDateTouched.current) {
                    setValue("dueDate", value, { shouldValidate: true });
                  }
                }}
                required
                label="Tanggal"
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            name="dueDate"
            control={control}
            render={({ field, fieldState }) => (
              <CustomDatePicker
                value={field.value}
                onChange={(value) => {
                  dueDateTouched.current = true;
                  field.onChange(value);
                }}
                required
                label="Jatuh Tempo"
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            name="expensePayableOutletChartOfAccount"
            control={control}
            render={({ field, fieldState }) => (
              <OutletChartOfAccountSelect
                outletId={outlet?.id}
                types={PAYABLE_ACCOUNT_TYPES}
                value={field.value}
                onChange={field.onChange}
                TextFieldProps={{
                  required: true,
                  label: "Hutang Beban",
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                  InputProps: {
                    placeholder: "Pilih Akun",
                  },
                }}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <CustomInputField
            name="note"
            label="Catatan"
            register={register}
            error={Boolean(errors.note)}
            helperText={errors.note?.message}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  editMode: PropTypes.bool,
};
